import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { debounce } from "lodash";
import { Breadcrumb, Input, Table, Space, Popconfirm, Tooltip } from "antd";
import { getRequest, postRequest } from "../../axios";
import SearchIcon from "../../image/SearchIcon.svg";
import "antd/dist/antd.min.css";
import "../../styles/Main.scss";
import { ReactComponent as ArchiveRestore } from "../../image/ArchiveRestore.svg";
import ButtonField from "../../common/htmlComponents/ButtonField";
import {
    ErrorNotificationMsg,
    SuccessNotificationMsg,
} from "../../utils/Notifications";

const { Search } = Input;

const ArchiveCompany = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    // const [archivedMaterialList, setArchivedMaterialList] = useState([]);
    const [archivecompanyList, setArchiveCompanyList] = useState([]);
    const [totalCount, settotalCount] = useState(0);
    const [selectedRow, setSelectedRow] = useState([]);

    const [state, setState] = useState({
        page: 1,
        ordering: "-id",
        pagesize: 10,
        search: "",
        total: 0,
    });

    useEffect(() => {
        const getMaterialArchiveList = async () => {
            setLoading(true);

            try {
                let apiResponse = await getRequest("company/archived-company-list/", state);
                if (apiResponse?.status) {
                    setArchiveCompanyList(apiResponse.data.results);
                    settotalCount(apiResponse.data.count);
                } else {
                    ErrorNotificationMsg(t("error_in_archived_material"));
                }
                setLoading(false);
            } catch (error) {
                setLoading(false);
            }
        };
        getMaterialArchiveList();
    }, [state, t]);

    const handleTableChange = async (pagination, filters, sorter, ordering) => {
        const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
        setState({
            ...state,
            page: pagination.current,
            pagesize: pagination.pageSize,
            ordering: orderBy,
        });
    };

    const GetSortingEnumValue = (sortField, sortOrder) => {
        let sortingEnumKey = "id";

        if (sortField === "company_name" && sortOrder === "ascend") {
            sortingEnumKey = "company_name";
        }
        if (sortField === "company_name" && sortOrder === "descend") {
            sortingEnumKey = "-company_name";
        }
        if (sortField === "company_email" && sortOrder === "ascend") {
            sortingEnumKey = "company_email";
        }
        if (sortField === "company_email" && sortOrder === "descend") {
            sortingEnumKey = "-company_email";
        }

        if (sortField === "company_street_address" && sortOrder === "ascend") {
            sortingEnumKey = "company_street_address";
        }
        if (sortField === "company_street_address" && sortOrder === "descend") {
            sortingEnumKey = "-company_street_address";
        }

        if (sortField === "company_number" && sortOrder === "ascend") {
            sortingEnumKey = "company_number";
        }
        if (sortField === "company_number" && sortOrder === "descend") {
            sortingEnumKey = "-company_number";
        }

        if (sortField === "company_contact_name" && sortOrder === "ascend") {
            sortingEnumKey = "company_contact_name";
        }
        if (sortField === "company_contact_name" && sortOrder === "descend") {
            sortingEnumKey = "-company_contact_name";
        }

        if (sortField === "company_abn_no" && sortOrder === "ascend") {
            sortingEnumKey = "company_abn_no";
        }
        if (sortField === "company_abn_no" && sortOrder === "descend") {
            sortingEnumKey = "-company_abn_no";
        }
        if (sortField === "company_note" && sortOrder === "ascend") {
            sortingEnumKey = "company_note";
        }
        if (sortField === "company_note" && sortOrder === "descend") {
            sortingEnumKey = "-company_note";
        }

        return sortingEnumKey;
    };

    const searchCallbackDelayed = (event) => {
        const { value } = event.target;
        debounceLoadData(value, onSearch);
    };
    const onSearch = (value) => {
        setState({
            ...state,
            search: value,
        });
    };

    const debounceLoadData = debounce((value, onSearch) => {
        onSearch(value);
    }, 1000);
    const rowSelection = {
        onChange: (selectedRowKeys) => {
            setSelectedRow(selectedRowKeys);
        },
    };

    const handleRestore = async (id = "") => {
        let ids = selectedRow;
        if (ids.length === 0) {
            ids.push(id);
        }
        try {
            let apiResponse = await postRequest("company/restore-company/", {
                deleted: ids,
            });
            if (apiResponse.data.success) {
                SuccessNotificationMsg(t("company_restore_successfully"));
                setSelectedRow([]);
                navigate("/company-onboarding");
            } else {
                ErrorNotificationMsg(t("error_in_restore_company"));
            }
        } catch (error) {
            ErrorNotificationMsg(error);
        }
    };
    // const openImageInNewTab = (imageSrc) => {
    //     window.open(imageSrc, "_blank");
    // };

    const columns = [
        {
            title: "Name",
            dataIndex: "company_name",
            key: "company_name",
            sorter: true,
            width: 150,
            // render: (dataIndex) => (
            //     <Tooltip
            //         color={colors}
            //         placement="left"
            //         title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
            //     >
            //         <div
            //             style={{
            //                 maxWidth: "400px",
            //                 whiteSpace: "nowrap",
            //                 overflow: "hidden",
            //                 textOverflow: "ellipsis",
            //             }}
            //         >
            //             {dataIndex}
            //         </div>
            //     </Tooltip>
            // ),
        },

        {
            title: "E-mail",
            dataIndex: "company_email",
            key: "company_email",
            sorter: true,
            render: (dataIndex) => (
                // <Tooltip
                //     color={colors}
                //     placement="left"
                //     // title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
                //     title={<span style={{ color: "#fff" }}>{dataIndex.toLowerCase()}</span>}
                // >
                    <div
                        style={{
                            maxWidth: "400px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            textTransform: 'lowercase',
                        }}
                    >
                        {dataIndex.toLowerCase()}
                    </div>
                // </Tooltip>
            ),
        },
        {
            title: "Address",
            dataIndex: "company_street_address",
            key: "company_street_address",
            sorter: true,
            render: (dataIndex) => (
                // <Tooltip
                //     color={colors}
                //     placement="left"
                //     title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
                // >
                    <div
                        style={{
                            maxWidth: "400px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                        }}
                    >
                        {dataIndex}
                    </div>
                // </Tooltip>
            ),
        },

        {
            title: "Contact Number",
            dataIndex: "company_number",
            key: "company_number",
            width: 180,
            render: (number) => {
                // Assuming phone is a number or string containing the phone number
                if (number) {
                    // Remove any non-numeric characters from the phone number
                    const cleanedPhone = String(number).replace(/\D/g, "");

                    // Check if the cleaned phone number starts with "+91" or any other country code
                    if (cleanedPhone.startsWith("91")) {
                        // Format as +91 xxxxx xxxxx (for Indian numbers)
                        return `+91 ${cleanedPhone.slice(2, 7)} ${cleanedPhone.slice(7)}`;
                    } else {
                        // Default format: +{country code} xxxxx xxxxx (adjust as per your country code format)
                        return `+${cleanedPhone}`;
                    }
                }
                return null; // Handle null or undefined cases
            },
            sorter: true,
        },
        {
            title: "Contact Name",
            dataIndex: "company_contact_name",
            key: "company_contact_name",
            sorter: true,
            width: 130,
            // render: (dataIndex) => (
            //     <Tooltip
            //         color={colors}
            //         placement="left"
            //         title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
            //     >
            //         <div
            //             style={{
            //                 maxWidth: "400px",
            //                 whiteSpace: "nowrap",
            //                 overflow: "hidden",
            //                 textOverflow: "ellipsis",
            //             }}
            //         >
            //             {dataIndex}
            //         </div>
            //     </Tooltip>
            // ),
        },
        {
            title: "ABN Number",
            dataIndex: "company_abn_no",
            key: "company_abn_no",
            sorter: true,
            width: 130,
        },

        {
            title: "Note",
            dataIndex: "company_note",
            key: "company_note",
            sorter: true,
            width: 180,
            render: (dataIndex) => (
                // <Tooltip
                //     color={colors}
                //     placement="left"
                //     title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
                // >
                    <div
                        style={{
                            maxWidth: "400px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                        }}
                    >
                        {dataIndex}
                    </div>
                // </Tooltip>
            ),
        },
        // {
        //   title: "Depo Address",
        //   dataIndex: "depo_address",
        //   key: "depo_address",
        //   sorter: true,
        //   width: 130,
        // },
        {
            title: "Action",
            key: "operation",
            fixed: "right",
            width: 130,
            render: (text, record) => (
                <Space>
                    {/* <Tooltip
                        color={colors}
                        placement="right"
                        title={<span style={{ color: "#fff" }}>Restore</span>}
                    > */}
                        <Popconfirm
                            className="action"
                            title={t("pop_restore_title")}
                            okText={t("pop_ok")}
                            cancelText={t("pop_cancel")}
                            onConfirm={() => handleRestore(record.id)}
                        >
                            <ArchiveRestore className="ArchiverestorImg" />{" "}
                        </Popconfirm>
                    {/* </Tooltip> */}
                </Space>
            ),
        },
    ];
    const colors = ["#737373"];
    return (
        <>
            <div className="ListingTopBar">
                <div className="pagenamewrap">
                    <div className="pagename">
                        {/* <Tooltip
                            color={colors}
                            placement="right"
                            title={
                                <span style={{ color: "#fff" }}>
                                    View details of the archived material, including description, category, and supplier.
                                </span>
                            }
                        > */}
                            <h3>{t("Archive Companies")}</h3>
                        {/* </Tooltip> */}

                        <Breadcrumb className="Breadcrumb-Sec">
                            <Breadcrumb.Item>
                                <Link to="/dashboard">{t("home")}</Link>
                            </Breadcrumb.Item>
                            <Breadcrumb.Item>
                                <Link to="/company-onboarding">{t("Manage Companies")}</Link>
                            </Breadcrumb.Item>
                            <Breadcrumb.Item>{t("Archive Companies")}</Breadcrumb.Item>
                        </Breadcrumb>
                    </div>
                    <Space>
                        <div className="searchwrp">
                            <Space direction="vertical">
                                <Search
                                    prefix={
                                        <img
                                            src={SearchIcon}
                                            alt="SearchIcon"
                                            className="SearchIcon"
                                            width={22}
                                        />
                                    }
                                    placeholder={t("pl_search_list")}
                                    onChange={searchCallbackDelayed}
                                    style={{
                                        width: 250,
                                    }}
                                />
                            </Space>
                        </div>
                        {selectedRow.length > 0 && (
                            <Popconfirm
                                className="action"
                                title={t("pop_restore_title")}
                                okText={t("pop_ok")}
                                cancelText={t("pop_cancel")}
                                placement="left"
                                onConfirm={() => handleRestore()}
                            >
                                <ButtonField
                                    className="BlueShadowBtn"
                                    type="primary"
                                    htmlType="button"
                                    label="Restore"
                                />
                            </Popconfirm>
                        )}
                    </Space>
                </div>
            </div>

            <section className="grid-sec">
                <div className="PR-body">
                    <Table
                        rowSelection={rowSelection}
                        columns={columns}
                        rowKey={(record) => record.id}
                        dataSource={archivecompanyList}
                        loading={loading}
                        pagination={{
                            defaultCurrent: state.page,
                            defaultPageSize: state.pagesize,
                            total: totalCount,
                            showTotal: (total) => `Total ${total} items`,
                            showSizeChanger: true,
                            locale: {
                                items_per_page: "Items / Page", // Text for the size changer
                            },
                        }}
                        onChange={handleTableChange}
                        scroll={{ x: 1200 }}
                    />
                    <div className="FormFooter Container">
                        <ButtonField
                            className="SaveGradiantBtn"
                            type="primary"
                            htmlType="button"
                            label={t("Back To List")}
                            onClick={() =>
                                navigate(
                                    `/company-onboarding`
                                )
                            }
                        //onClick={() => setCurrentIndex(0)}
                        />
                    </div>
                </div>

            </section>

        </>
    );
};

export default ArchiveCompany;
